/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteAppointmentRequest
 */
export interface DeleteAppointmentRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteAppointmentRequest
     */
    reason: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeleteAppointmentRequest
     */
    notifyBySms?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeleteAppointmentRequest
     */
    notifyByEmail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeleteAppointmentRequest
     */
    originTimeZoneId?: string | null;
}

/**
 * Check if a given object implements the DeleteAppointmentRequest interface.
 */
export function instanceOfDeleteAppointmentRequest(value: object): value is DeleteAppointmentRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function DeleteAppointmentRequestFromJSON(json: any): DeleteAppointmentRequest {
    return DeleteAppointmentRequestFromJSONTyped(json, false);
}

export function DeleteAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'notifyBySms': json['notifyBySms'] == null ? undefined : json['notifyBySms'],
        'notifyByEmail': json['notifyByEmail'] == null ? undefined : json['notifyByEmail'],
        'originTimeZoneId': json['originTimeZoneId'] == null ? undefined : json['originTimeZoneId'],
    };
}

export function DeleteAppointmentRequestToJSON(json: any): DeleteAppointmentRequest {
    return DeleteAppointmentRequestToJSONTyped(json, false);
}

export function DeleteAppointmentRequestToJSONTyped(value?: DeleteAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'notifyBySms': value['notifyBySms'],
        'notifyByEmail': value['notifyByEmail'],
        'originTimeZoneId': value['originTimeZoneId'],
    };
}

